import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import ListItem from '@material-ui/core/ListItem'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Avatar from '@material-ui/core/Avatar'
import Checkbox from '@material-ui/core/Checkbox'
import PersonIcon from '@material-ui/icons/Person'
import classNames from 'classnames'
import { deleteContact, getContact } from '../../actions/contacts'
import { selectContact } from '../../actions/contacts/addOrEdit'
import {
	addContactsToGroup,
	removeContactsFromGroup,
} from '../../actions/contacts/groups'
import MoreMenu from './MoreMenu'

export const detail = (contact) => {
	if (contact?.phones) {
    return contact?.phones[0].number
  } else if (contact?.email) {
    return contact?.email[0].address
  } else {
    return ''
  }
}

export const styles = (theme) => ({
	avatarRoot: {
		borderRadius: 9,
		color: '#fff',
		backgroundColor: '#13b940',
	},
	button: {
		margin: theme.spacing.unit,
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		[theme.breakpoints.down('sm')]: {
			width: '100%',
		},
		[theme.breakpoints.up('md')]: {
			flexBasis: '33.33%',
			flexShrink: 0,
		},
	},
	panelContent: {
		position: 'relative',
		display: 'flex',
		padding: '13px 60px 11px 81px',
		width: '100%',
	},
	panel: {
		backgroundColor: '#fff',
		padding: 0,
		height: 64,
		'&:hover': {
			'&$panelCheckbox': {
				display: 'inline-flex',
			},
		},
		borderBottom: '1px solid #e0e0e0',
	},
	secondaryHeading: {
		fontSize: theme.typography.pxToRem(15),
		color: theme.palette.text.secondary,
		[theme.breakpoints.down('sm')]: {
			display: 'none',
		},
	},
	panelCheckbox: { display: 'none' },
	colorDefault: { color: '#fff' },
	left: {
		position: 'absolute',
		left: 7,
		top: 4,
	},
	right: {
		position: 'absolute',
		right: 50,
		top: '-9px',
	},
	container: {
		listStyle: 'none',
	},
	checkbox: {
		position: 'absolute',
		left: '-4px',
		top: '-3px',
	},
	checkboxContainer: {
		position: 'relative',
	},
})

export default withRouter(
  connect(
    (state, { contact }) => ({
      selected: Boolean(state.contacts?.selectedContacts?.[contact?.id]),
    }),
    dispatch =>
      bindActionCreators(
        {
          deleteContact,
          addContactsToGroup,
          removeContactsFromGroup,
          selectContact,
          getContact,
        },
        dispatch,
      ),
  )(
    withStyles(styles)(
      class PanelComponent extends Component {
        render() {
          const {
            classes,
            contact,
            selected,
            history,
            selectContact,
            groupID,
          } = this.props

          return (
            <ListItem
              className={classNames(classes.panel, 'contact-expansion-panel')}
              button
              onClick={() => history.push(`/contacts/${contact?.id}`)}
              classes={{
                container: classes.container,
              }}
            >
              <div className={classes.panelContent}>
                <div className={classes.left}>
                  <div className={classes.checkboxContainer}>
                    <div className={classes.checkbox}>
                      <Checkbox
                        onClick={e => e.stopPropagation()}
                        checked={selected ? true : false}
                        onChange={e => selectContact(contact, e.target.checked)}
                        className="contact-expansion-panel-checkbox"
                        classes={{
                          root: selected ? null : classes.panelCheckbox,
                        }}
                      />
                    </div>
                  </div>
                  <Avatar
                    style={selected ? { display: 'none' } : null}
                    className={'contact-expansion-panel-avatar'}
                    classes={{
                      root: classes.avatarRoot,
                      colorDefault: classes.colorDefault,
                    }}
                  >
                    {contact?.first_name ||
                    contact?.middle_name ||
                    contact?.last_name ? (
                      `${
                        contact?.first_name
                          ? `${contact?.first_name.slice(0, 1)}`
                          : ''
                      }${
                        contact?.middle_name &&
                        (!contact?.first_name || !contact?.last_name)
                          ? `${contact?.middle_name.slice(0, 1)}`
                          : ''
                      }${
                        contact?.last_name
                          ? `${contact?.last_name.slice(0, 1)}`
                          : ''
                      }`
                    ) : (
                      <PersonIcon />
                    )}
                  </Avatar>
                </div>
                <Typography noWrap className={classes.heading}>
                  {contact?.first_name ||
                  contact?.middle_name ||
                  contact?.last_name
                    ? `${contact?.first_name ? `${contact?.first_name} ` : ''}${
                        contact?.middle_name ? `${contact?.middle_name} ` : ''
                      }${contact?.last_name ? `${contact?.last_name} ` : ''}`
                    : detail(contact)}
                </Typography>
                <Typography noWrap className={classes.secondaryHeading}>
                  {contact?.first_name ||
                  contact?.middle_name ||
                  contact?.last_name
                    ? detail(contact)
                    : null}
                </Typography>
              </div>
              <ListItemSecondaryAction>
                <MoreMenu
                  index={this.props.index}
                  campaignID={this.props.campaignID}
                  groupID={groupID}
                  // contactID={contact?.id}
                  contact={contact}
                  deleteThenFn={this.props.deleteThenFn}
                />
              </ListItemSecondaryAction>
            </ListItem>
          )
        }
      },
    ),
  ),
)
